import request from "@/util/http"; // 留言列表查询

export var getLeaveMsgList = function getLeaveMsgList(params) {
  return request({
    url: "/admin/personalCenter/leaveMsg/list",
    method: "get",
    params: params
  });
}; // 留言详情

export var getLeaveMsgDetail = function getLeaveMsgDetail(params) {
  return request({
    url: "/admin/personalCenter/leaveMsg/detail",
    method: "get",
    params: params
  });
}; // 留言详情

export var getLeaveMsgRepeat = function getLeaveMsgRepeat(params) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/personalCenter/leaveMsg/repeat",
    method: "post",
    data: JSON.stringify(params)
  });
}; // 留言列表查询

export var getAdviceList = function getAdviceList(params) {
  return request({
    url: "/admin/personalCenter/advice/list",
    method: "get",
    params: params
  });
}; // 留言列表查询

export var getAdviceTypeList = function getAdviceTypeList() {
  return request({
    url: "/admin/personalCenter/advice/type/list",
    method: "get"
  });
};